import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';

const DATALAYER_NAME = getPublicRuntimeConfig('DATALAYER_NAME');

interface CommonEventData {
  event: string;
  'gtm.uniqueEventId': number;
}

export function findGtmEvent<T extends CommonEventData>(eventName: string): T | null {
  const events = (window?.[DATALAYER_NAME] || []) as T[];
  return events.find((evt) => evt?.event === eventName) || null;
}

function wait(milliseconds: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, milliseconds);
  });
}

/** Some events are not triggered by our code, but via some 3rd party tools. In
 * such cases this function is useful to make sure events are sent in the
 * expected order */
export async function waitForGtmEvent(eventName: string, maxWaitTimeSeconds = 15): Promise<void> {
  const maxTries = maxWaitTimeSeconds * 10;
  const waitTimeMs = 100;
  let triesCount = 0;
  while (findGtmEvent(eventName) === null && triesCount++ < maxTries) {
    await wait(waitTimeMs);
  }
}
